module.exports = __webpack_public_path__ + "img/pop_img_guide.684882d2.png";